class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.mainSummary = this.mainDetailsToggle.querySelector("summary");
    this.content = this.mainSummary.nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    this.content.setAttribute("role", "region");

    const startHeight = `${this.mainSummary.offsetHeight / 10}rem`;
    const endHeight = `${this.mainDetailsToggle.offsetHeight / 10}rem`;
    // eslint-disable-next-line no-undef
    const config = animationConfig();

    this.animation = this.mainDetailsToggle.animate(
      {
        height: [startHeight, endHeight],
      },
      config
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    // eslint-disable-next-line no-undef
    event.preventDefault();
    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", "");
    this.mainSummary.setAttribute("aria-expanded", true);
  }

  close() {
    this.animation.cancel();
    this.mainDetailsToggle.removeAttribute("open");
    this.mainSummary.setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class DetailsAccordion extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector("details");
    this.summary = this.el.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));

    this.open = this.open.bind(this);
    this.shrink = this.shrink.bind(this);
    this.expand = this.expand.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    const config = animationConfig();
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      config
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    const config = animationConfig();
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      config
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}

customElements.define("details-accordion", DetailsAccordion);
